import { Component, ElementRef, Inject, Input, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EventSidebarFilterComponent } from '../../event/event-sidebar-filter/event-sidebar-filter.component';
import { EventSidebarListComponent } from '../../event/event-sidebar-list/event-sidebar-list.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  NgbAccordionBody,
  NgbAccordionButton,
  NgbAccordionCollapse,
  NgbAccordionDirective,
  NgbAccordionHeader,
  NgbAccordionItem,
  NgbNav,
  NgbNavContent,
  NgbNavItem,
  NgbNavItemRole,
  NgbNavModule,
} from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, RouterLink, RouterLinkActive } from '@angular/router';
import { CurrentMeetService } from '../../shared/services/current-meet.service';
import { MeetList } from '@athleticnet/athletic-live-api-models';
import { Observable, Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { IsSidebarOpenService } from '../../shared/services/is-sidebar-open.service';
import { TeamListComponent } from '../../team/team-list/team-list.component';
import { EventSidebarComponent } from '../../event/event-sidebar/event-sidebar.component';
import { LiveSidebarComponent } from '../../live/live-sidebar/live-sidebar.component';
import { SidebarSearchComponent } from '../sidebar-search/sidebar-search.component';
import { TimezoneToggleComponent } from '../../shared/timezone-toggle/timezone-toggle.component';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { AuthService } from '../../shared/anet/auth/auth.service';
import { AthleticFollowInfo } from '../../shared/anet/models/athletic-follow-info.interface';
import { SiteConfigService } from '../../shared/services/site-config.service';
import { SiteConfigInterface } from '../../shared/models/config/site-config.interface';
import { IsDarkModeService } from '../../shared/services/is-dark-mode.service';
import { LocaleToggleComponent } from '../../shared/locale-toggle/locale-toggle.component';
import { MeetDatePipe } from '../../shared/pipes/meet-date.pipe';

@Component({
  selector: 'app-mobile-sidebar',
  standalone: true,
  imports: [
    CommonModule,
    NgbNavModule,
    FontAwesomeModule,
    RouterLink,
    RouterLinkActive,
    TeamListComponent,
    EventSidebarComponent,
    LiveSidebarComponent,
    SidebarSearchComponent,
    TimezoneToggleComponent,
    NgbAccordionBody,
    NgbAccordionButton,
    NgbAccordionCollapse,
    NgbAccordionDirective,
    NgbAccordionHeader,
    NgbAccordionItem,
    LocaleToggleComponent,
    MeetDatePipe,
  ],
  templateUrl: './mobile-sidebar.component.html',
  styleUrls: ['./mobile-sidebar.component.scss'],
})
export class MobileSidebarComponent {
  @ViewChild('secondSideMenu') secondSideMenu!: ElementRef;
  @ViewChild('backgroundCurtain') backgroundCurtain!: ElementRef;
  @Input() meet!: MeetList;
  activeTab = 'home';
  isSidebarOpenServiceSubscription!: Subscription;
  isDarkMode$!: Observable<boolean>;
  followInfo$!: Observable<AthleticFollowInfo | null>;
  siteConfig$!: Observable<SiteConfigInterface | null>;

  constructor(
    public route: ActivatedRoute,
    public isSidebarOpenService: IsSidebarOpenService,
    private isDarkModeService: IsDarkModeService,
    public authService: AuthService,
    private siteConfigService: SiteConfigService,
  ) {
    this.isDarkMode$ = this.isDarkModeService.isDarkMode;
    this.siteConfig$ = this.siteConfigService.updateSiteConfig;
    this.isSidebarOpenServiceSubscription = this.isSidebarOpenService.isSidebarOpen.subscribe((isSidebarOpen) => {
      if (this.secondSideMenu) {
        if (isSidebarOpen) {
          this.secondSideMenu.nativeElement.classList.add('second-side-menu--open');
        } else {
          this.secondSideMenu.nativeElement.classList.remove('second-side-menu--open');
        }
      }
      if (this.backgroundCurtain) {
        if (isSidebarOpen) {
          this.backgroundCurtain.nativeElement.classList.add('open');
        } else {
          this.backgroundCurtain.nativeElement.classList.remove('open');
        }
      }
    });
  }

  ngOnInit() {
    this.followInfo$ = this.authService.updateFollowInfo;
  }

  onDarkModeToggle() {
    this.isDarkModeService.toggleDarkMode();
  }

  ngOnDestroy() {
    if (this.isSidebarOpenServiceSubscription) {
      this.isSidebarOpenServiceSubscription.unsubscribe();
    }
  }

  protected readonly environment = environment;
}
